import { Expose, Type } from 'class-transformer';
import { ApprovedStatus } from '@core/enums';
import { InitializableEntity } from '@core/entities/_extra/intializable.entity';
import { UserEntity } from '@core/entities';

export class BaseEntity<T = any> extends InitializableEntity {
  id: number;

  @Expose({ name: 'team_id' })
  teamId: string | number = 0;

  @Expose({ name: 'user_id' })
  userId: string | number;

  @Expose({ name: 'approved_status' })
  approvedStatus: ApprovedStatus = ApprovedStatus.UnApproved;

  @Expose({ name: 'approved_by' })
  approvedBy: any;

  @Expose({ name: 'is_read' })
  isRead?: number;

  @Expose({ name: 'updated_record' })
  updatedRecord?: T | null;

  @Expose({ name: 'update_approved_status' })
  updateApprovedStatus?: any | null;

  @Expose({ name: 'deny_reason' })
  denyReason: string;

  @Expose({ name: 'deny_by_id' })
  denyById: number;

  @Expose({ name: 'denybyuser' })
  @Type(() => UserEntity)
  denyByUser: UserEntity;

  @Expose({ name: 'created_at' })
  createdAt: string;

  @Expose({ name: 'updated_at' })
  updatedAt: string;

  modifiedAt: string;

  @Expose({ name: 'created_by' })
  createdBy = 0;

  @Expose({ name: 'createdby' })
  @Type(() => UserEntity)
  createdByUser?: UserEntity;

  constructor(init?: Partial<BaseEntity>) {
    super(init);
    this.initEntity(init);
  }
}
